/** Lato di una bolla chat nel dettaglio thread.
 *
 * "mine" = SOLO il nostro shop (destra, accent). "operator" = customer-care
 * del MARKETPLACE che inoltra/assiste il cliente: va a SINISTRA con stile
 * proprio (bug 2026-06-11: compariva a destra come i nostri messaggi e la
 * chat era illeggibile). "customer" = cliente finale.
 *
 * NB: il backend mantiene la semantica legacy ``is_outgoing`` (OPERATOR
 * incluso nel lato shop) per needs_reply e auto-reply: questa funzione è
 * SOLO presentazione.
 */
export type MessageSide = "mine" | "operator" | "customer";

export function messageSide(message: {
  sender_type: string | null;
  sender_org_type: string | null;
}): MessageSide {
  const type = message.sender_type ?? "";
  const org = message.sender_org_type ?? "";
  if (type === "OPERATOR_USER" || org === "OPERATOR") return "operator";
  if (type === "SHOP_USER" || type === "SELLER" || org === "SHOP" || org === "SELLER") {
    return "mine";
  }
  return "customer";
}

/** Canali dove la risposta parte SOLO come testo: il backend rifiuta gli
 *  allegati (ValidationError), quindi non si offre nemmeno il tasto. Va tenuto
 *  allineato ai connettori Amazon, ManoMano e WhatsApp. */
const CANALI_SENZA_ALLEGATI = new Set(["amazon", "manomano", "whatsapp"]);

export function canaleAccettaAllegati(source: string): boolean {
  return !CANALI_SENZA_ALLEGATI.has(source);
}

/** Nome da mostrare sopra la bolla. Gli operator Mirakl arrivano col nome
 *  generico "Operator": lo sostituiamo con un'etichetta comprensibile. */
export function senderLabel(message: { sender_name: string | null }, side: MessageSide): string {
  if (side === "operator") return "Assistenza marketplace";
  return message.sender_name || (side === "mine" ? "Tu" : "Cliente");
}
